import visualizationService from "../../services/visualizationService";
import { data, dummyData, dummyData2, sampleFolders } from "./dummyData";
import { initialState } from "./initialState";
import * as types from "./types";
import { errorMessage } from "../../constants/responseMessages";

export const fetchPlot = (payload) => async (dispatch) => {
  dispatch({
    type: types.FETCH_PLOT_STATE,
    payload: {
      loader: true,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });

  try {
    const plotJson = await visualizationService.getPlotData(payload);

    const hasValidData = (plotJson) => {
      if (!plotJson || typeof plotJson !== "object") {
        return false;
      }

      const hasInfo = plotJson?.info !== undefined && plotJson?.info !== null;
      const hasPlotData =
        plotJson?.plot_data !== undefined && plotJson?.plot_data !== null;

      return hasInfo && hasPlotData;
    };

    if (!hasValidData(plotJson)) {
      dispatch({
        type: types.FETCH_PLOT_STATE,
        payload: {
          loader: false,
          error: true,
          message: "Something went wrong while fetching the plot.",
          data: null,
        },
      });
      return null;
    }

    // const isErrorResponse = plotJson?.status?.[0] >= 400 || plotJson?.body;

    // if (isErrorResponse) {
    //   let detailedError = "Something went wrong while fetching the plot.";

    //   try {
    //     const bodyJson = plotJson?.body?.[0]
    //       ? JSON.parse(plotJson.body[0])
    //       : null;

    //     if (bodyJson?.details)
    //       detailedError = `${detailedError} - ${bodyJson.details}`;
    //     else if (bodyJson?.error)
    //       detailedError = `${detailedError} - ${bodyJson.error}`;
    //   } catch (parseErr) {
    //     detailedError = "Something went wrong while fetching the plot.";
    //   }

    //   dispatch({
    //     type: types.FETCH_PLOT_STATE,
    //     payload: {
    //       loader: false,
    //       error: true,
    //       message: detailedError,
    //       data: null,
    //     },
    //   });
    //   return;
    // }

    dispatch({
      type: types.FETCH_PLOT_STATE,
      payload: { loader: false, data: plotJson, success: true, error: false },
    });
    return plotJson;
  } catch (err) {
    dispatch({
      type: types.FETCH_PLOT_STATE,
      payload: {
        loader: false,
        error: true,
        message: errorMessage(err),
        data: null,
      },
    });
    // setTimeout(() => {
    //   dispatch({
    //     type: types.FETCH_PLOT_STATE,
    //     payload: {
    //       loader: false,
    //       data: dummyData2,
    //       success: true,
    //       error: false,
    //     },
    //   });
    // }, 5000);
  }
};

export const clearPlot = () => (dispatch) => {
  dispatch({
    type: types.FETCH_PLOT_STATE,
    payload: {
      loader: false,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });
};

export const fetchProductsSitesAndUnitOfOperations = () => async (dispatch) => {
  dispatch({
    type: types.FETCH_PRODUCT_SITES_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response =
      await visualizationService.fetchProductsSitesAndUnitOfOperations();
    dispatch({
      type: types.FETCH_PRODUCT_SITES_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: response.data, // assumes response has `data`
      },
    });
  } catch (error) {
    dispatch({
      type: types.FETCH_PRODUCT_SITES_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

// export const clearProductsSitesAndUnitOfOperations = () => async (dispatch) => {
//   dispatch({
//     type: types.FETCH_PRODUCT_SITES_LIST,
//     payload: {},
//   });
// };

export const fetchParameterList = (payload) => async (dispatch) => {
  dispatch({
    type: types.FETCH_PARAMETER_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await visualizationService.fetchParameterList(payload);
    dispatch({
      type: types.FETCH_PARAMETER_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: response, // assumes response has `data`
      },
    });
  } catch (error) {
    dispatch({
      type: types.FETCH_PARAMETER_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const fetchFilteredBatchList = (payload) => async (dispatch) => {
  dispatch({
    type: types.FETCH_FILTERED_BATCH_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });

  try {
    const response = await visualizationService.fetchFilteredBatchList(payload);
    dispatch({
      type: types.FETCH_FILTERED_BATCH_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: response, // assumes response has `data`
      },
    });
    return response;
  } catch (error) {
    dispatch({
      type: types.FETCH_FILTERED_BATCH_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });

    dispatch({
      type: types.FETCH_FILTERED_BATCH_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        data: [
          {
            batch_id: "3000000998",
            batch_date: "22-Jan-2026",
          },
          {
            batch_id: "3000000997",
            batch_date: "22-Jan-2026",
          },
          {
            batch_id: "22",
            batch_date: "11-Dec-2025",
          },
          {
            batch_id: "8921481",
            batch_date: "24-Oct-2025",
          },
          {
            batch_id: "80049391480",
            batch_date: "14-Oct-2025",
          },
          {
            batch_id: "8921473",
            batch_date: "10-Oct-2025",
          },
          {
            batch_id: "8921472",
            batch_date: "10-Oct-2025",
          },
          {
            batch_id: "8921003",
            batch_date: "08-Oct-2025",
          },
          {
            batch_id: "8921002",
            batch_date: "07-Oct-2025",
          },
          {
            batch_id: "3000051030",
            batch_date: "07-Oct-2025",
          },
          {
            batch_id: "3000007999",
            batch_date: "06-Oct-2025",
          },
          {
            batch_id: "3000054444",
            batch_date: "03-Oct-2025",
          },
          {
            batch_id: "3000050977",
            batch_date: "24-Sep-2025",
          },
          {
            batch_id: "3000050957",
            batch_date: "15-Sep-2025",
          },
          {
            batch_id: "8921001",
            batch_date: "10-Aug-2025",
          },
          {
            batch_id: "3000007892",
            batch_date: "04-Jul-2025",
          },
          {
            batch_id: "3000007891",
            batch_date: "03-Jul-2025",
          },
          {
            batch_id: "3000007890",
            batch_date: "03-Jul-2025",
          },
          {
            batch_id: "3000007889",
            batch_date: "03-Jul-2025",
          },
          {
            batch_id: "3000007888",
            batch_date: "02-Jul-2025",
          },
          {
            batch_id: "3000007887",
            batch_date: "01-Jul-2025",
          },
          {
            batch_id: "3000007886",
            batch_date: "01-Jul-2025",
          },
          {
            batch_id: "3000007884",
            batch_date: "30-Jun-2025",
          },
          {
            batch_id: "3000007883",
            batch_date: "30-Jun-2025",
          },
          {
            batch_id: "3000007848",
            batch_date: "27-Jun-2025",
          },
          {
            batch_id: "3000007847",
            batch_date: "27-Jun-2025",
          },
          {
            batch_id: "3000007846",
            batch_date: "27-Jun-2025",
          },
          {
            batch_id: "3000007845",
            batch_date: "26-Jun-2025",
          },
          {
            batch_id: "3000007844",
            batch_date: "26-Jun-2025",
          },
          {
            batch_id: "3000007843",
            batch_date: "26-Jun-2025",
          },
          {
            batch_id: "3000007842",
            batch_date: "25-Jun-2025",
          },
          {
            batch_id: "3000007841",
            batch_date: "25-Jun-2025",
          },
          {
            batch_id: "3000007840",
            batch_date: "25-Jun-2025",
          },
          {
            batch_id: "3000007839",
            batch_date: "24-Jun-2025",
          },
          {
            batch_id: "3000007838",
            batch_date: "24-Jun-2025",
          },
          {
            batch_id: "3000007837",
            batch_date: "23-Jun-2025",
          },
          {
            batch_id: "3000007836",
            batch_date: "23-Jun-2025",
          },
          {
            batch_id: "3000007735",
            batch_date: "20-Jun-2025",
          },
          {
            batch_id: "3000007734",
            batch_date: "20-Jun-2025",
          },
          {
            batch_id: "3000007733",
            batch_date: "19-Jun-2025",
          },
          {
            batch_id: "3000007732",
            batch_date: "19-Jun-2025",
          },
          {
            batch_id: "3000007731",
            batch_date: "19-Jun-2025",
          },
          {
            batch_id: "3000007730",
            batch_date: "18-Jun-2025",
          },
          {
            batch_id: "3000007729",
            batch_date: "18-Jun-2025",
          },
          {
            batch_id: "3000007728",
            batch_date: "18-Jun-2025",
          },
          {
            batch_id: "3000007727",
            batch_date: "17-Jun-2025",
          },
          {
            batch_id: "3000007726",
            batch_date: "17-Jun-2025",
          },
          {
            batch_id: "3000007725",
            batch_date: "17-Jun-2025",
          },
          {
            batch_id: "3000007724",
            batch_date: "16-Jun-2025",
          },
          {
            batch_id: "3000007689",
            batch_date: "16-Jun-2025",
          },
          {
            batch_id: "3000007688",
            batch_date: "05-Jun-2025",
          },
          {
            batch_id: "3000007687",
            batch_date: "05-Jun-2025",
          },
          {
            batch_id: "3000007686",
            batch_date: "04-Jun-2025",
          },
          {
            batch_id: "3000007583",
            batch_date: "30-May-2025",
          },
          {
            batch_id: "3000007582",
            batch_date: "30-May-2025",
          },
          {
            batch_id: "3000007580",
            batch_date: "29-May-2025",
          },
          {
            batch_id: "3000007579",
            batch_date: "29-May-2025",
          },
          {
            batch_id: "3000007578",
            batch_date: "28-May-2025",
          },
          {
            batch_id: "3000007577",
            batch_date: "28-May-2025",
          },
          {
            batch_id: "3000007576",
            batch_date: "28-May-2025",
          },
          {
            batch_id: "3000007575",
            batch_date: "27-May-2025",
          },
          {
            batch_id: "3000007574",
            batch_date: "27-May-2025",
          },
          {
            batch_id: "3000007573",
            batch_date: "27-May-2025",
          },
          {
            batch_id: "3000007572",
            batch_date: "23-May-2025",
          },
          {
            batch_id: "3000007570",
            batch_date: "22-May-2025",
          },
          {
            batch_id: "3000007501",
            batch_date: "21-May-2025",
          },
          {
            batch_id: "3000007500",
            batch_date: "21-May-2025",
          },
          {
            batch_id: "3000007499",
            batch_date: "21-May-2025",
          },
          {
            batch_id: "3000007498",
            batch_date: "20-May-2025",
          },
          {
            batch_id: "3000007496",
            batch_date: "20-May-2025",
          },
          {
            batch_id: "3000007495",
            batch_date: "19-May-2025",
          },
          {
            batch_id: "3000007494",
            batch_date: "19-May-2025",
          },
          {
            batch_id: "3000007493",
            batch_date: "19-May-2025",
          },
          {
            batch_id: "3000007492",
            batch_date: "16-May-2025",
          },
          {
            batch_id: "3000007406",
            batch_date: "16-May-2025",
          },
          {
            batch_id: "3000007405",
            batch_date: "15-May-2025",
          },
          {
            batch_id: "3000007404",
            batch_date: "15-May-2025",
          },
          {
            batch_id: "3000007403",
            batch_date: "15-May-2025",
          },
          {
            batch_id: "3000007402",
            batch_date: "14-May-2025",
          },
          {
            batch_id: "3000007401",
            batch_date: "14-May-2025",
          },
          {
            batch_id: "3000007400",
            batch_date: "14-May-2025",
          },
          {
            batch_id: "3000007399",
            batch_date: "13-May-2025",
          },
          {
            batch_id: "3000007398",
            batch_date: "13-May-2025",
          },
          {
            batch_id: "3000007397",
            batch_date: "13-May-2025",
          },
          {
            batch_id: "3000007396",
            batch_date: "12-May-2025",
          },
          {
            batch_id: "3000007395",
            batch_date: "12-May-2025",
          },
          {
            batch_id: "3000007394",
            batch_date: "09-May-2025",
          },
        ], // assumes response has `data`
      },
    });
    return [
      {
        batch_id: "3000000998",
        batch_date: "22-Jan-2026",
      },
      {
        batch_id: "3000000997",
        batch_date: "22-Jan-2026",
      },
      {
        batch_id: "22",
        batch_date: "11-Dec-2025",
      },
      {
        batch_id: "8921481",
        batch_date: "24-Oct-2025",
      },
      {
        batch_id: "80049391480",
        batch_date: "14-Oct-2025",
      },
      {
        batch_id: "8921473",
        batch_date: "10-Oct-2025",
      },
      {
        batch_id: "8921472",
        batch_date: "10-Oct-2025",
      },
      {
        batch_id: "8921003",
        batch_date: "08-Oct-2025",
      },
      {
        batch_id: "8921002",
        batch_date: "07-Oct-2025",
      },
      {
        batch_id: "3000051030",
        batch_date: "07-Oct-2025",
      },
      {
        batch_id: "3000007999",
        batch_date: "06-Oct-2025",
      },
      {
        batch_id: "3000054444",
        batch_date: "03-Oct-2025",
      },
      {
        batch_id: "3000050977",
        batch_date: "24-Sep-2025",
      },
      {
        batch_id: "3000050957",
        batch_date: "15-Sep-2025",
      },
      {
        batch_id: "8921001",
        batch_date: "10-Aug-2025",
      },
      {
        batch_id: "3000007892",
        batch_date: "04-Jul-2025",
      },
      {
        batch_id: "3000007891",
        batch_date: "03-Jul-2025",
      },
      {
        batch_id: "3000007890",
        batch_date: "03-Jul-2025",
      },
      {
        batch_id: "3000007889",
        batch_date: "03-Jul-2025",
      },
      {
        batch_id: "3000007888",
        batch_date: "02-Jul-2025",
      },
      {
        batch_id: "3000007887",
        batch_date: "01-Jul-2025",
      },
      {
        batch_id: "3000007886",
        batch_date: "01-Jul-2025",
      },
      {
        batch_id: "3000007884",
        batch_date: "30-Jun-2025",
      },
      {
        batch_id: "3000007883",
        batch_date: "30-Jun-2025",
      },
      {
        batch_id: "3000007848",
        batch_date: "27-Jun-2025",
      },
      {
        batch_id: "3000007847",
        batch_date: "27-Jun-2025",
      },
      {
        batch_id: "3000007846",
        batch_date: "27-Jun-2025",
      },
      {
        batch_id: "3000007845",
        batch_date: "26-Jun-2025",
      },
      {
        batch_id: "3000007844",
        batch_date: "26-Jun-2025",
      },
      {
        batch_id: "3000007843",
        batch_date: "26-Jun-2025",
      },
      {
        batch_id: "3000007842",
        batch_date: "25-Jun-2025",
      },
      {
        batch_id: "3000007841",
        batch_date: "25-Jun-2025",
      },
      {
        batch_id: "3000007840",
        batch_date: "25-Jun-2025",
      },
      {
        batch_id: "3000007839",
        batch_date: "24-Jun-2025",
      },
      {
        batch_id: "3000007838",
        batch_date: "24-Jun-2025",
      },
      {
        batch_id: "3000007837",
        batch_date: "23-Jun-2025",
      },
      {
        batch_id: "3000007836",
        batch_date: "23-Jun-2025",
      },
      {
        batch_id: "3000007735",
        batch_date: "20-Jun-2025",
      },
      {
        batch_id: "3000007734",
        batch_date: "20-Jun-2025",
      },
      {
        batch_id: "3000007733",
        batch_date: "19-Jun-2025",
      },
      {
        batch_id: "3000007732",
        batch_date: "19-Jun-2025",
      },
      {
        batch_id: "3000007731",
        batch_date: "19-Jun-2025",
      },
      {
        batch_id: "3000007730",
        batch_date: "18-Jun-2025",
      },
      {
        batch_id: "3000007729",
        batch_date: "18-Jun-2025",
      },
      {
        batch_id: "3000007728",
        batch_date: "18-Jun-2025",
      },
      {
        batch_id: "3000007727",
        batch_date: "17-Jun-2025",
      },
      {
        batch_id: "3000007726",
        batch_date: "17-Jun-2025",
      },
      {
        batch_id: "3000007725",
        batch_date: "17-Jun-2025",
      },
      {
        batch_id: "3000007724",
        batch_date: "16-Jun-2025",
      },
      {
        batch_id: "3000007689",
        batch_date: "16-Jun-2025",
      },
      {
        batch_id: "3000007688",
        batch_date: "05-Jun-2025",
      },
      {
        batch_id: "3000007687",
        batch_date: "05-Jun-2025",
      },
      {
        batch_id: "3000007686",
        batch_date: "04-Jun-2025",
      },
      {
        batch_id: "3000007583",
        batch_date: "30-May-2025",
      },
      {
        batch_id: "3000007582",
        batch_date: "30-May-2025",
      },
      {
        batch_id: "3000007580",
        batch_date: "29-May-2025",
      },
      {
        batch_id: "3000007579",
        batch_date: "29-May-2025",
      },
      {
        batch_id: "3000007578",
        batch_date: "28-May-2025",
      },
      {
        batch_id: "3000007577",
        batch_date: "28-May-2025",
      },
      {
        batch_id: "3000007576",
        batch_date: "28-May-2025",
      },
      {
        batch_id: "3000007575",
        batch_date: "27-May-2025",
      },
      {
        batch_id: "3000007574",
        batch_date: "27-May-2025",
      },
      {
        batch_id: "3000007573",
        batch_date: "27-May-2025",
      },
      {
        batch_id: "3000007572",
        batch_date: "23-May-2025",
      },
      {
        batch_id: "3000007570",
        batch_date: "22-May-2025",
      },
      {
        batch_id: "3000007501",
        batch_date: "21-May-2025",
      },
      {
        batch_id: "3000007500",
        batch_date: "21-May-2025",
      },
      {
        batch_id: "3000007499",
        batch_date: "21-May-2025",
      },
      {
        batch_id: "3000007498",
        batch_date: "20-May-2025",
      },
      {
        batch_id: "3000007496",
        batch_date: "20-May-2025",
      },
      {
        batch_id: "3000007495",
        batch_date: "19-May-2025",
      },
      {
        batch_id: "3000007494",
        batch_date: "19-May-2025",
      },
      {
        batch_id: "3000007493",
        batch_date: "19-May-2025",
      },
      {
        batch_id: "3000007492",
        batch_date: "16-May-2025",
      },
      {
        batch_id: "3000007406",
        batch_date: "16-May-2025",
      },
      {
        batch_id: "3000007405",
        batch_date: "15-May-2025",
      },
      {
        batch_id: "3000007404",
        batch_date: "15-May-2025",
      },
      {
        batch_id: "3000007403",
        batch_date: "15-May-2025",
      },
      {
        batch_id: "3000007402",
        batch_date: "14-May-2025",
      },
      {
        batch_id: "3000007401",
        batch_date: "14-May-2025",
      },
      {
        batch_id: "3000007400",
        batch_date: "14-May-2025",
      },
      {
        batch_id: "3000007399",
        batch_date: "13-May-2025",
      },
      {
        batch_id: "3000007398",
        batch_date: "13-May-2025",
      },
      {
        batch_id: "3000007397",
        batch_date: "13-May-2025",
      },
      {
        batch_id: "3000007396",
        batch_date: "12-May-2025",
      },
      {
        batch_id: "3000007395",
        batch_date: "12-May-2025",
      },
      {
        batch_id: "3000007394",
        batch_date: "09-May-2025",
      },
    ];
  }
};

export const clearFilteredBatchList = () => (dispatch) => {
  dispatch({
    type: types.FETCH_FILTERED_BATCH_LIST,
    payload: { ...initialState?.apiStatus },
  });
};

export const clearParameterList = () => (dispatch) => {
  dispatch({
    type: types.FETCH_PARAMETER_LIST,
    payload: { ...initialState?.apiStatus },
  });
};

export const fetchSavedVizList = (requestData) => async (dispatch) => {
  dispatch({
    type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  // dispatch({
  //   type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
  //   payload: {
  //     data: { ...data },
  //   },
  // });
  try {
    const response = await visualizationService.fetchSavedVizList(requestData);
    dispatch({
      type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response,
      },
    });
  } catch (error) {
    dispatch({
      type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
    // dispatch({
    //   type: types.FETCH_SAVED_VIZ_LIST_REQUEST,
    //   payload: {
    //     data: { ...data },
    //   },
    // });
  }
};

export const fetchFolders = (requestData) => async (dispatch) => {
  dispatch({
    type: types.FETCH_FOLDER_REQUEST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  dispatch({
    type: types.FETCH_FOLDER_REQUEST,
    payload: {
      data: sampleFolders,
    },
  });
  try {
    const response = await visualizationService.getFolders(requestData);
    dispatch({
      type: types.FETCH_FOLDER_REQUEST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data?.data,
      },
    });
  } catch (error) {
    // dispatch({
    //   type: FETCH_FOLDER_REQUEST,
    //   payload: {
    //     ...initialState.apiStatus,
    //     loader: false,
    //     message: errorMessage(error),
    //     apiError: true,
    //   },
    // });
    dispatch({
      type: types.FETCH_FOLDER_REQUEST,
      payload: {
        data: sampleFolders,
      },
    });
  }
};

export const saveVisualization = (payload) => async (dispatch) => {
  dispatch({
    type: types.SAVE_VIZ_REQUEST,
    payload: {
      loader: true,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });

  try {
    const res = await visualizationService.saveVisualization(payload);
    dispatch({
      type: types.SAVE_VIZ_REQUEST,
      payload: { loader: false, data: res, success: true, error: false },
    });
    return res; // ✅ return result so component can await
  } catch (err) {
    dispatch({
      type: types.SAVE_VIZ_REQUEST,
      payload: {
        loader: false,
        error: true,
        message: errorMessage(err),
        data: null,
      },
    });
    throw err; // ✅ throw error so component can catch
  }
};

export const fetchSavedVisualization = (payload) => async (dispatch) => {
  // dispatch({
  //   type: types.FETCH_SAVED_VIZ_DETAILS,
  //   payload: {
  //     loader: true,
  //     error: false,
  //     message: "",
  //     data: null,
  //     success: false,
  //   },
  // });

  try {
    const data = await visualizationService.fetchSavedVisualization(payload);
    return data;
    // dispatch({
    //   type: types.FETCH_SAVED_VIZ_DETAILS,
    //   payload: {
    //     ...initialState,
    //     loader: false,
    //     data: data,
    //     success: true,
    //     error: false,
    //   },
    // });
  } catch (err) {
    throw err;

    //   dispatch({
    //     type: types.FETCH_SAVED_VIZ_DETAILS,
    //     payload: {
    //       loader: false,
    //       error: true,
    //       message: err.message,
    //       data: null,
    //     },
    //   });
  }
};

export const setViewEditPlotDatToState = (payload) => (dispatch) => {
  dispatch({
    type: types.FETCH_PLOT_STATE,
    payload: { loader: false, data: payload, success: true, error: false },
  });
};

